import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SupportTicket, getTicketPriorityName, getTicketStatusName, isTicketDone } from "../../common/user";
import { getUserMessage } from "../../common/exceptions";
import { UserService } from "../user.service";
import { Column } from "../../ui-components/table/table-component";

interface TicketRow {
    _key:number
    subject:string
    type:string
    priority:string
    status:string
    created_at:Date
    due_by:Date
    updated_at:Date
}

@Component({
    selector: 'app-ticket-list',
    templateUrl: './ticket-list.html',
    styleUrls: ['./ticket-list.css'],
    standalone: false
})
export class TicketListComponent implements OnInit {
    loading = false
    loaded = false
    error:string|undefined
    data:TicketRow[] = []
    openCount = 0

    columns = [
        new Column('subject', 'Subject', 'string'),
        new Column('type', 'Type', 'string'),
        new Column('priority', 'Priority', 'string'),
        new Column('status', 'Status', 'string'),
        new Column('created_at', 'Raised', 'date'),
        new Column('due_by', 'Due', 'date'),
        new Column('updated_at', 'Updated', 'date'),
    ]

    @Output() countChanged = new EventEmitter<number>()

    constructor(private userService:UserService) {
    }

    ngOnInit() {
        this.refreshTickets()
    }

    async refreshTickets() {
        this.loading = true
        this.error = undefined
        try {
            const tickets:SupportTicket[] = await this.userService.getSupportTickets() || []
            this.data = tickets
                .map(t => ({
                    _key: t.id,
                    subject: t.subject,
                    type: t.type || '',
                    priority: getTicketPriorityName(t.priority),
                    status: getTicketStatusName(t.status),
                    created_at: t.created_at,
                    // a due date only matters while the ticket is being worked on
                    due_by: isTicketDone(t.status) ? undefined : t.due_by,
                    updated_at: t.updated_at,
                }))
                .sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime())
            this.openCount = tickets.filter(t => !isTicketDone(t.status)).length
            this.countChanged.emit(this.data.length)
        }catch(err) {
            this.error = getUserMessage(err)
        }finally {
            this.loading = false
            this.loaded = true
        }
    }
}
